export const PASSINGS_PATH = '/passings';